import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["value", "className"];
import React from 'react';
import { SwitchInput, createUseStyles } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'Checkbox');
function Checkbox(_ref) {
  let {
      value,
      className
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const classes = useStyles();
  const classNames = classnames(className, classes.root, `checkbox-input__active--${value}`);
  return /*#__PURE__*/React.createElement(SwitchInput, _extends({
    labelMode: "horizontal",
    value: value,
    className: classNames
  }, props, {
    isFullWidth: false
  }));
}
export default Checkbox;